var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "login-wrapper"
  }, [_vm._m(0), _c("div", {
    staticClass: "login-right"
  }, [_vm._m(1), _c("div", {
    staticClass: "subtle-bg-circle subtle-bg-1"
  }), _c("div", {
    staticClass: "subtle-bg-circle subtle-bg-2"
  }), _c("div", {
    staticClass: "subtle-bg-circle subtle-bg-3"
  }), _c("div", {
    staticClass: "form-container"
  }, [_c("div", {
    staticClass: "form-header"
  }, [_c("h2", {
    staticClass: "form-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("login.title")) + " ")]), _c("p", {
    staticClass: "form-subtitle"
  }, [_vm._v(" Enter your credentials to access your account ")])]), _c("el-form", {
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      model: _vm.loginForm,
      rules: _vm.loginRules,
      autocomplete: "on",
      "label-position": "left"
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleLogin.apply(null, arguments);
      }
    }
  }, [_c("div", {
    staticClass: "form-group"
  }, [_c("label", {
    staticClass: "form-label"
  }, [_vm._v("Email Address")]), _c("el-input", {
    ref: "email",
    staticClass: "minimal-input",
    attrs: {
      placeholder: _vm.$t("login.email"),
      name: "email",
      type: "text",
      autocomplete: "on",
      "prefix-icon": "el-icon-user"
    },
    model: {
      value: _vm.loginForm.email,
      callback: function ($$v) {
        _vm.$set(_vm.loginForm, "email", $$v);
      },
      expression: "loginForm.email"
    }
  })], 1), _c("div", {
    staticClass: "form-group"
  }, [_c("label", {
    staticClass: "form-label"
  }, [_vm._v("Password")]), _c("el-input", {
    key: _vm.passwordType,
    ref: "password",
    staticClass: "minimal-input",
    attrs: {
      type: _vm.passwordType,
      placeholder: _vm.$t("login.password"),
      name: "password",
      autocomplete: "on",
      "prefix-icon": "el-icon-lock"
    },
    model: {
      value: _vm.loginForm.password,
      callback: function ($$v) {
        _vm.$set(_vm.loginForm, "password", $$v);
      },
      expression: "loginForm.password"
    }
  }, [_c("span", {
    staticClass: "toggle-password",
    attrs: {
      slot: "suffix"
    },
    on: {
      click: _vm.showPwd
    },
    slot: "suffix"
  }, [_c("svg-icon", {
    attrs: {
      name: _vm.passwordType === "password" ? "eye-off" : "eye-on"
    }
  })], 1)])], 1), _c("el-button", {
    staticClass: "login-button",
    attrs: {
      loading: _vm.loading,
      type: "primary"
    },
    nativeOn: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.handleLogin.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("login.logIn")) + " ")])], 1)], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "login-left"
  }, [_c("div", {
    staticClass: "brand-container"
  }, [_c("div", {
    staticClass: "logo-wrapper"
  }, [_c("img", {
    staticClass: "logo-image",
    attrs: {
      src: "/img/osum-logo-white.png",
      alt: "Logo"
    }
  })]), _c("p", {
    staticClass: "brand-tagline"
  }, [_vm._v(" Access your secure account and manage your business ")]), _c("div", {
    staticClass: "brand-features"
  }, [_c("div", {
    staticClass: "feature-item"
  }, [_c("div", {
    staticClass: "feature-icon"
  }, [_vm._v(" 🔒 ")]), _c("span", [_vm._v("Enterprise Grade Security")])]), _c("div", {
    staticClass: "feature-item"
  }, [_c("div", {
    staticClass: "feature-icon"
  }, [_vm._v(" ⚡ ")]), _c("span", [_vm._v("Lightning Fast Performance")])]), _c("div", {
    staticClass: "feature-item"
  }, [_c("div", {
    staticClass: "feature-icon"
  }, [_vm._v(" 🌐 ")]), _c("span", [_vm._v("Access From Anywhere")])])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "nova-background"
  }, [_c("div", {
    staticClass: "nova-circle nova-1"
  }), _c("div", {
    staticClass: "nova-circle nova-2"
  }), _c("div", {
    staticClass: "nova-circle nova-3"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };